import { Link } from "react-router-dom";
import { useTranslation } from "../i18n";

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center max-w-md animate-slideUp">
        <div className="text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-nm-primary to-nm-accent mb-4">
          404
        </div>
        <h1 className="mb-3 text-3xl font-bold text-ink">{t("notFound.title")}</h1>
        <p className="mb-8 text-ink-soft">
          {t("notFound.body")}
        </p>
        <Link to="/" className="btn-primary inline-block">
          ← {t("common.returnHome")}
        </Link>
      </div>
    </div>
  );
}
